import React, { useState } from "react";
import { Auth } from "aws-amplify";
import { useRequest } from "ahooks";
import AuthLayout from "../../layouts/AuthLayout";
import { useHistory } from "react-router-dom";
import { toast } from "react-toastify";
import { useTranslation } from "react-i18next";
import { Button, PasswordInput, Text, TextInput } from "@mantine/core";

const ForgotPassword: React.FC = () => {
  const { t } = useTranslation();
  const history = useHistory();
  const [sent, setSent] = useState(false);

  const handleForgotPassword = async ({ email }: { email: string }) => {
    try {
      await Auth.forgotPassword(email);
      toast.success("Verification code sent to your email");
    } catch (err: any) {
      toast.error(err?.message);
      return false;
    }
    return true;
  };

  const handlePasswordSubmit = async ({
    code,
    email,
    password,
  }: {
    code: string;
    email: string;
    password: string;
  }) => {
    try {
      await Auth.forgotPasswordSubmit(email, code, password);
      toast.success("Password successfully changed");
      history.push("/dashboard/login");
    } catch (err: any) {
      toast.error(err?.message);
      return false;
    }
    return true;
  };

  const forgotPasswordAction = useRequest(
    (values) => handleForgotPassword(values),
    {
      manual: true,
      onSuccess: () => setSent(true),
    },
  );

  const passwordSubmitAction = useRequest(
    (values) => handlePasswordSubmit(values),
    {
      manual: true,
    },
  );

  const handleSubmit = (e: any) => {
    e.preventDefault();

    const email = e.target["email"].value;

    if (!e.target["code"]) {
      forgotPasswordAction.run({ email });
    } else {
      const code = e.target["code"].value;
      const password = e.target["password"].value;
      const confirmPassword = e.target["confirmPassword"].value;

      if (password === confirmPassword) {
        passwordSubmitAction.run({ email, code, password });
      } else {
        toast.error("Password confirmation does not match");
      }
    }
  };

  return (
    <AuthLayout>
      <div className="card">
        <form className="form" onSubmit={handleSubmit}>
          <div className="form__row">
            <Text>{t("email")}</Text>
            <TextInput
              name="email"
              type="email"
              placeholder={t("email")}
              required
            />
          </div>

          {sent && (
            <>
              <div className="form__row">
                <Text>{t("password")}</Text>
                <PasswordInput
                  name="password"
                  placeholder={t("password")}
                  required
                />
              </div>
              <div className="form__row">
                <Text>{t("confirmPassword")}</Text>
                <PasswordInput
                  name="confirmPassword"
                  placeholder={t("confirmPassword")}
                  required
                />
              </div>
              <div className="form__row">
                <Text>{t("code")}</Text>
                <TextInput
                  name="code"
                  type="text"
                  placeholder={t("code")}
                  required
                />
              </div>
            </>
          )}
          <div className="form__row">
            {sent ? (
              <Button
                size="lg"
                loading={forgotPasswordAction.loading}
                disabled={forgotPasswordAction.loading}
                type="submit"
                fullWidth
              >
                Change Password
              </Button>
            ) : (
              <Button
                size="lg"
                loading={passwordSubmitAction.loading}
                disabled={passwordSubmitAction.loading}
                type="submit"
                fullWidth
              >
                Send verification code
              </Button>
            )}
          </div>
        </form>
      </div>
    </AuthLayout>
  );
};

export default ForgotPassword;
